import moment, { Moment } from 'moment';

import { ProgramExtensionStatusReason } from '../enums';
import { DATE_FORMAT } from '../utils/constants';
import { make } from './Model';
import { ProgramExtensionStatus } from './ProgramExtensionStatus';

export class MemberDashboardBHI {
  programExtensionStatus: ProgramExtensionStatus;

  programExtensionStatusReason?: ProgramExtensionStatusReason;

  programExtensionStatusReasonOther = '';

  bhiTotalMinutes = 0;

  lastCompletedDate?: Moment;

  lastCompletedEmployee = '';

  lastCarePlanDate?: Moment;

  lastCarePlanEmployee = '';

  constructor(obj: any) {
    Object.assign(this, obj);
    this.programExtensionStatus = make(
      obj.programExtensionStatus,
      ProgramExtensionStatus,
    );
    this.programExtensionStatusReason = obj.programExtensionStatusReason
      ? ProgramExtensionStatusReason.byKey[obj.programExtensionStatusReason]
      : undefined;
    this.lastCompletedDate = obj.lastCompletedDate
      ? moment(obj.lastCompletedDate, DATE_FORMAT)
      : undefined;
    this.lastCarePlanDate = obj.lastCarePlanDate
      ? moment(obj.lastCarePlanDate, DATE_FORMAT)
      : undefined;
  }
}

export default MemberDashboardBHI;
